import axios from 'axios';

export const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
  timeout: 20000,
});

// Token fallback (we rely on httpOnly cookie primarily)
let bearer = null;
export const setBearer = (t) => {
  bearer = t || null;
  if (t) localStorage.setItem('modaria_token', t);
  else localStorage.removeItem('modaria_token');
};
export const restoreBearer = () => {
  const t = localStorage.getItem('modaria_token');
  bearer = t || null;
  return bearer;
};

// ─── Interceptor: reescribe URLs a archivos .php directos ──────────────
// Permite servir el backend PHP en cualquier hosting sin depender de
// rewrites en .htaccess o nginx. Cada URL del frontend se mapea a un
// archivo .php físico (y los segmentos dinámicos pasan como ?id=, ?section=, etc.).
function rewritePhpUrl(url) {
  if (!url || url.includes('.php')) return url;
  const u = url.startsWith('/') ? url.slice(1) : url;

  // /admin/leads/export.csv → /admin/leads.php?export=csv
  if (/^admin\/leads\/export\.csv\/?$/.test(u)) {
    return '/admin/leads.php?export=csv';
  }
  // /admin/leads/{id} → /admin/leads.php?id=xxx
  let m = u.match(/^admin\/leads\/([^/?]+)\/?$/);
  if (m) return `/admin/leads.php?id=${encodeURIComponent(m[1])}`;

  // /admin/content/{section} → /admin/content.php?section=xxx
  m = u.match(/^admin\/content\/([^/?]+)\/?$/);
  if (m) return `/admin/content.php?section=${encodeURIComponent(m[1])}`;

  // /admin/media/{id}/enabled → /admin/media.php?id=xxx&action=enabled
  m = u.match(/^admin\/media\/([^/?]+)\/enabled\/?$/);
  if (m) return `/admin/media.php?id=${encodeURIComponent(m[1])}&action=enabled`;
  // /admin/media/{id}/regenerate-variants → idem
  m = u.match(/^admin\/media\/([^/?]+)\/regenerate-variants\/?$/);
  if (m) return `/admin/media.php?id=${encodeURIComponent(m[1])}&action=regenerate`;
  // /admin/media/{id} → /admin/media.php?id=xxx
  m = u.match(/^admin\/media\/([^/?]+)\/?$/);
  if (m) return `/admin/media.php?id=${encodeURIComponent(m[1])}`;

  // /admin/settings/smtp/test → /admin/settings.php?key=smtp&action=test
  if (/^admin\/settings\/smtp\/test\/?$/.test(u)) {
    return '/admin/settings.php?key=smtp&action=test';
  }
  // /admin/settings/{key} → /admin/settings.php?key=xxx
  m = u.match(/^admin\/settings\/([^/?]+)\/?$/);
  if (m) return `/admin/settings.php?key=${encodeURIComponent(m[1])}`;

  // /media/by-section/{section} → /media/by-section.php?section=xxx
  m = u.match(/^media\/by-section\/([^/?]+)\/?$/);
  if (m) return `/media/by-section.php?section=${encodeURIComponent(m[1])}`;

  // Endpoints planos: auth/login, content, contact, admin/stats, etc.
  m = u.match(/^(auth\/login|auth\/logout|auth\/me|auth\/forgot-password|auth\/reset-password|content|contact|admin\/stats|admin\/leads|admin\/media|admin\/upload|impact\/baseline|compliance\/sample-likeness|compliance\/sample-report)\/?$/);
  if (m) return `/${m[1]}.php`;

  // Root /api/ → /api/health.php
  if (u === '' || u === '/') return '/health.php';

  return url;
}

api.interceptors.request.use((config) => {
  if (bearer) config.headers.Authorization = `Bearer ${bearer}`;
  if (config.url) config.url = rewritePhpUrl(config.url);
  return config;
});

export const apiUrl = (path) => `${API_BASE}${path}`;

export function pickLocale(value, locale = 'es', fallback = '') {
  if (value == null) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'object') return value[locale] ?? value.es ?? value.en ?? fallback;
  return String(value);
}

export function formatApiError(detail) {
  if (detail == null) return 'Algo salió mal. Inténtalo de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
